import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactPlayer from 'react-player';
import { mediaQueries } from '@general/breakpoints';

const EmbedContainer = styled.div`
    position: relative;
    height: ${props => (props.containerHeight ? 'calc(5rem + 20vh)' : 'auto')};
    padding-top: ${props => (props.containerHeight ? '0' : '56.25%')};

    @media ${mediaQueries.lg} {
        height: ${props => (props.containerHeight ? props.containerHeight : 'auto')};
    }
`;

const StyledReactPlayer = styled(ReactPlayer)`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`;

/**
 * Video Embed container that supports ReactPlayer's API
 * Docs: https://github.com/cookpete/react-player
 *
 * @property videoSrc - URL of embeddable video (no params)
 * @property containerHeight - pass a supported measurement for CSS height, if none, it fills its container.
 */
const VideoEmbed = ({ videoSrc, containerHeight }) => (
    <EmbedContainer containerHeight={containerHeight}>
        <StyledReactPlayer width="100%" height="100%" url={videoSrc} volume={0} controls playing muted loop />
    </EmbedContainer>
);

VideoEmbed.propTypes = {
    videoSrc: PropTypes.string.isRequired,
    containerHeight: PropTypes.string,
};

export default VideoEmbed;
